import { translateFromCatalogs, type LocaleCatalogs } from "./catalog";
import type { AppLocale } from "./locales";
import { parsePo } from "./parsePo";
import dePo from "./messages/timepilot/de.po";
import elPo from "./messages/timepilot/el.po";
import enPo from "./messages/timepilot/en.po";
import esPo from "./messages/timepilot/es.po";

export const TIMEPILOT_CATALOGS: LocaleCatalogs = {
  en: parsePo(enPo),
  el: parsePo(elPo),
  es: parsePo(esPo),
  de: parsePo(dePo),
};

export function translateTimePilotMessage(
  locale: AppLocale,
  key: string,
  values?: Record<string, string | number>,
): string {
  return translateFromCatalogs(TIMEPILOT_CATALOGS, locale, key, values);
}
